import { type IMarket, MarketStatus } from "~/types/event";

export enum MarketSettlementKind {
  OPEN = "open",
  DISPUTED = "disputed",
  SETTLED = "settled",
}

export type MarketResult = NonNullable<IMarket["result"]>;

export interface IMarketSettlement {
  kind: MarketSettlementKind;
  result: MarketResult | null;
  resolvedAt: string | null;
}

const kindByStatus: Record<MarketStatus, MarketSettlementKind> = {
  [MarketStatus.ACTIVE]: MarketSettlementKind.OPEN,
  [MarketStatus.PROPOSED]: MarketSettlementKind.DISPUTED,
  [MarketStatus.DISPUTED]: MarketSettlementKind.DISPUTED,
  [MarketStatus.RESOLVED]: MarketSettlementKind.SETTLED,
  [MarketStatus.CLOSED]: MarketSettlementKind.SETTLED,
};

export const getMarketSettlement = (market: IMarket): IMarketSettlement => {
  const kind = kindByStatus[market.unifiedStatus];

  if (kind !== MarketSettlementKind.SETTLED) {
    return { kind, result: null, resolvedAt: null };
  }

  return {
    kind,
    result: market.result ?? null,
    resolvedAt: market.resolvedAt ?? null,
  };
};
